<template>
  <div
    class="combine"
    :class="{ athena_combine: theme == 'athena' }"
    v-if="
      combinations &&
      combinations.status &&
      combinations.items &&
      combinations.items.length > 1
    "
  >
    <!-- <h5>{{ combinations && combinations.title }}</h5> -->
    <!-- 款式组合 - 缩略图 -->
    <div class="combine_items c_thumbnail">
      <div
        class="combine_item"
        v-for="item in combinations.items"
        :key="item.product_id"
      >
        <a
          @click.prevent.stop="$emit('update:productDetail', item.product)"
          :class="{ acitve: item.ID == productDetail.ID }"
        >
          <img
            @error.once="imageFailure($event, defaultImage)"
            :src="
              (item.is_main_image && item.product && item.product.image) ||
              item.product_image ||
              defaultImage
            "
            class="lazyload"
            data-sizes="auto"
            alt
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "combinations",
    "combination_active",
    "theme",
    "productDetail",
    "updateProduct",
  ],
  data() {
    return {
      show_options: false,
    };
  },
  methods: {
    // option_click(index) {
    //   this.combination_active = index;
    // },
  },
  mounted() {
    // if (this.combinations.items && this.combinations.items.length > 1) {
    //   this.combinations.items.forEach((item, index) => {
    //     if (item.ID == this.productDetail.ID) {
    //       this.combination_active = index;
    //     }
    //   });
    // }
  },
};
</script>

<style scoped lang='scss'>
.combine {
  margin-top: 20px;
  h5 {
    margin-bottom: 10px;
    font-size: 16px;
    color: #2b2b2b;
    font-weight: bold;
  }
  .combine_items {
    display: flex;
    flex-wrap: nowrap;
    .combine_item {
      margin: 0 15px 10px 0;
      img {
        width: 46px;
        height: 46px;
        object-fit: cover;
      }
    }
  }
  .c_thumbnail {
    margin: 0 -7.5px;
    .combine_item {
      margin: 0 0 10px 0;
      padding: 0 7.5px;
    }
    a {
      display: block;
      &.acitve {
        border: 1px solid #222222;
      }
    }
  }
  .c_imagetext {
    justify-content: space-between;
    .combine_item {
      margin: 0 0 10px 0;
      width: 48%;
      img {
        width: 38px;
        height: 38px;
      }
      a {
        display: flex;
        align-items: center;
        padding: 4px;
        border: 1px solid #eee;
        &.acitve {
          border-color: #222222;
        }
        span {
          margin-left: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
      }
    }
  }
}

.select_x {
  position: relative;
  cursor: pointer;
  .select_item {
    margin: 0 0 10px 0;
    .arrow_icon_up {
      position: absolute;
      right: 10px;
      top: calc(50% - 2.5px);
      border-top: 2px solid #ccc;
      border-right: 2px solid #ccc;
      transform: rotate(-45deg);
      width: 10px;
      height: 10px;
    }
    .arrow_icon_down {
      position: absolute;
      right: 10px;
      border-top: 2px solid #ccc;
      border-right: 2px solid #ccc;
      transform: rotate(135deg);
      width: 10px;
      height: 10px;
    }
    img {
      width: 38px;
      height: 38px;
      object-fit: cover;
    }
    a {
      display: flex;
      align-items: center;
      padding: 5px;
      border: 1px solid #eee;
      span {
        margin-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        padding-right: 20px;
      }
    }
  }
  .option_box_x {
    .option_x {
      cursor: pointer;
      a {
        border: none;
      }
      &:hover {
        background-color: #eee;
      }
    }
    position: absolute;
    width: 100%;
    left: 5px;
    max-height: 200px;
    overflow-y: auto;
    padding: 6px 0;
    border: 1px solid #eee;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 4px;
    z-index: 999;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      opacity: 0;
      transition: opacity 120ms ease-out;
      &:hover {
        opacity: 1;
      }
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(144, 147, 153, 0.3);
      transition: 0.3s background-color;
    }
    &::-webkit-scrollbar-track-piece {
      background-color: #fff;
    }
  }
  .arrow_icon {
    position: absolute;
    bottom: -15px;
    left: 30px;
    border-top: 1px solid #eee;
    border-right: 1px solid #eee;
    transform: rotate(-45deg);
    width: 10px;
    height: 10px;
    background-color: #fff;
  }
  .arrow_icon2 {
    position: absolute;
    bottom: -11px;
    left: 29px;
    width: 12px;
    height: 1px;
    background-color: #fff;
    z-index: 999;
  }
}
.combine.athena_combine {
  margin-top: 20px;
  h5 {
    margin-bottom: 20px;
    font-size: 20px;
    color: #3a3a3a;
    font-weight: bold;
  }
  .c_thumbnail {
    a {
      border: 1px solid #cccccc;
      display: block;
      border-radius: 50%;
      padding: 3px;
      width: 52px;
      height: 52px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      &.acitve {
        border: 2px solid #222222;
      }
    }
  }
}
@media screen and(max-width:768px) {
  .combine {
    .c_imagetext {
      .combine_item {
        a {
          span {
            -webkit-line-clamp: 2;
            line-height: 22px;
          }
        }
      }
    }
  }

  .combine.athena_combine {
    h5 {
      margin-bottom: 0;
      font-size: 13px;
      line-height: 36px;
    }
    .c_thumbnail {
      // justify-content: center;
      margin: 0;
      overflow-x: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .combine_item {
        padding: 0 2.5px;
      }
      a {
        width: 38px;
        height: 38px;
        padding: 2px;
      }
    }
  }
  .m_hidden {
    display: none;
  }
}
</style>
